export const canProcessBeStopped = (p: string) => {
  return (
    [
      'Debug and Management Server',
      'svc',
      'edm',
      'rpmStateCenter',
      'Media Controller Interface',
    ].indexOf(p) === -1
  )
}
